import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { MedicalOrderModel } from "@/modules/MedicalOrder/models/MedicalOrderModel";
import {
  ORDER_CONSTANTS,
  ORDER_STATES
} from "@/modules/Orders/constants/OrderConstants";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  CUPS,
  GENERAL_RULES_CONSTANTS,
  ID_LIST,
  ORDER_FORM_LABELS
} from "../../constants/GeneralRulesConstants";
import {
  BILL_TYPE_LIST,
  LACK_OF_OPTIONS
} from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { ListService } from "@/modules/List/services/ListService";
import { Response } from "@/shared/models/Response";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { CupsPriceLevelHeader } from "@/modules/CupsPriceLevels/models/CupsPriceLevelHeader";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { Utils } from "@/shared/utils/utils";
import { SERVICES_CONTANTS } from "@/modules/Services/constants/ServicesConstants";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import CustomFieldsDisplay from "../CustomFieldsDisplay/CustomFieldsDisplay.vue";
import { MedicalOrderField } from "@/modules/MedicalOrder/models/MedicalOrderField";
import { DataTransferActions } from "../../models/DataTransferActions.model";
import { LevelPrice } from "../../models/LevelPrice.model";
import Vuetify from "vuetify";
import { PreventKey } from "@/shared/mixins/mixins";
import { AxiosError } from "axios";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { ActionGeneralRules } from "../../models/actions.model";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";

Vue.use(Vuetify);
@Component({
  name: "Order",
  components: {
    CustomFieldsDisplay,
    DynamicSelect
  }
})
export default class Order extends PreventKey {
  @Inject() listService!: ListService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() serviceTemplateService!: ServiceTemplateService;

  @Prop() serviceTemplates!: ServiceTemplateHeader[];
  @Prop() actionToEdit!: ActionGeneralRules;
  @Prop() indexInContainer!: number;
  @Prop() actionType!: string;
  @Prop() edit!: boolean;
  @Prop() campusList!: string[];
  @Prop() diagnosisCodes!: string[];
  @Prop() fieldsOrder!: FieldOrder[];
  @Prop() priceLvlsListProps!: { keys: string[]; values: string[] };
  @Prop() dataTransferActions!: DataTransferActions;
  @Prop() collectionName!: string;
  @Prop() sessionOrderService?: boolean;
  @Prop() orderStates?: { id: string; name: string }[];
  @Prop() ruleId?: string;

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  STATE_LABEL = ORDER_CONSTANTS.LABELS.STATE;
  DIAG_CODE = ORDER_CONSTANTS.LABELS.DIAG_CODE;
  PRICE_LEVEL = ORDER_CONSTANTS.LABELS.PRICE_LEVEL.slice(0, -1);
  EVENT = ORDER_CONSTANTS.LABELS.EVENT.slice(0, -1);
  BILL_TYPE = ORDER_CONSTANTS.LABELS.BILL_TYPE;
  CAMPUS = ORDER_CONSTANTS.LABELS.CAMPUS;
  DESCRIPTION = ORDER_CONSTANTS.LABELS.DESCRIPTION.slice(0, -1);
  ORDER_TYPE = ORDER_CONSTANTS.LABELS.ORDER_TYPE;
  CANCEL_VALUE = ORDER_CONSTANTS.LABELS.CANCEL_VALUE.slice(0, -1);
  CUPS = CUPS.slice(0, -1);
  SERVICE = GENERAL_RULES_CONSTANTS.TITLE_BUTTON_SERVICES;
  ORDER_STATES_LIST: string[] = Object.values(ORDER_STATES);
  ORDER_TYPES_LIST = ORDER_CONSTANTS.ORDER_TYPE;
  BILL_TYPE_LIST = BILL_TYPE_LIST.map(item => item.key);
  DIAGNOSIS_CODES: string[] = [];
  ORDER_FORM_LABELS = ORDER_FORM_LABELS;
  cupsStore: CupsPriceLevelHeader[] = [];
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  cupsList: { keys: string[]; values: string[] } = { keys: [], values: [] };
  serviceTemplatesList: { keys: string[]; values: string[] } = {
    keys: [],
    values: []
  };
  priceLvlsList: { keys: string[]; values: string[] } = {
    keys: [],
    values: []
  };
  campusToSelect: string[] = [];
  CUSTOM_FIELDS = GENERAL_RULES_CONSTANTS.CUSTOM_FIELDS;
  COLLECTIONS_REQUIRE_SERVICE =
    GENERAL_RULES_CONSTANTS.COLLECTIONS_REQUIRE_SERVICE;
  orderFieldsList: string[] = [];
  fieldSelected: FieldOrder = new FieldOrder();
  disableSaveButton = true;
  fetchCustomFields = false;
  cleanCustomFields = false;
  visibleSession = false;
  fieldsToEdit = {};
  levelPriceStore: LevelPrice[] = [];
  daysToApply = 0;
  activeSelect = false;
  orderForm = false;
  requiredArrayFields = [FORM_VALIDATORS.REQUIRED_ARRAY];
  order: MedicalOrderModel = {
    user: "",
    service: "",
    cups: "",
    priceLevel: "",
    billType: "",
    state: "",
    campus: "",
    diagnosticPrimaryCode: "",
    description: "",
    orderType: "",
    event: "",
    type: "",
    payment: 0,
    cancelValue: 0,
    fields: {}
  };
  orderServiceModel = [{ id: "", name: "" }];
  orderStateModel = [{ id: "", name: "" }];
  diagCodeModel = [{ id: "", name: "" }];
  billTypeModel = [{ id: "", name: "" }];
  orderPriceModel = [{ id: "", name: "" }];
  campusModel = [{ id: "", name: "" }];
  cupsModel = [{ id: "", name: "" }];
  isGroupType = false;

  serviceSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.SERVICE,
    hideDetails: false
  };
  orderStateSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.STATE_LABEL,
    hideDetails: false,
    required: true
  };
  diagnosticSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.DIAG_CODE,
    hideDetails: false,
    required: false
  };
  billTypeSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: this.BILL_TYPE_LIST.map(item => {
      return { id: item, name: item };
    }),
    filled: false,
    messageLabel: this.BILL_TYPE,
    hideDetails: false
  };
  orderPriceSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.PRICE_LEVEL,
    hideDetails: false
  };
  cupsSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.CUPS,
    hideDetails: false
  };

  campusSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: this.CAMPUS,
    hideDetails: false
  };
  editComparationStr = "";
  invalidEdit = false;
  invalidEditCustoms = false;
  async mounted() {
    await this.getServiceTemplates();
    this.orderStateSelectConfig.listAll = this.orderStates as {
      id: string;
      name: string;
    }[];
    this.priceLvlsList = this.priceLvlsListProps;
    this.serviceSelectConfig.listAll = this.serviceTemplatesList.values.map(
      item => {
        return { id: item, name: item };
      }
    );
    this.orderPriceSelectConfig.listAll = this.priceLvlsList.values.map(
      item => {
        return { id: item, name: item };
      }
    );
    await this.getCups();
    this.campusToSelect = this.campusList;
    this.campusSelectConfig.listAll = this.campusToSelect.map(item => {
      return { id: item, name: item };
    });
    this.DIAGNOSIS_CODES = this.diagnosisCodes;
    this.diagnosticSelectConfig.listAll = this.DIAGNOSIS_CODES.map(item => {
      return { id: item, name: item };
    });

    await this.getServiceDafault();
    if (this.edit) {
      this.invalidEditCustoms = true;
      this.invalidEdit = true;
      await this.preloadForm(this.actionToEdit);
    } else {
      if (this.order.service) {
        const indexServicetemplate = this.serviceTemplatesList.values.findIndex(
          service => service === this.order.service
        );
        this.selectServiceField = this.order.service as string;
        const serviceSelectedId =
          indexServicetemplate >= 0
            ? this.serviceTemplatesList.keys[indexServicetemplate]
            : "";
        await this.getServiceTemplate(serviceSelectedId);
      }
    }

    this.visibleSession =
      this.dataTransferActions.collectionName !==
      ORDER_CONSTANTS.COLLECTIONS.SESIONES
        ? true
        : false;
  }

  get selectServiceField() {
    return this.orderServiceModel[0].id;
  }

  set selectServiceField(value: string) {
    const option = this.serviceSelectConfig.listAll.find(
      item => item.id === value
    );
    this.orderServiceModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get orderSelectState() {
    return this.orderStateModel[0].id;
  }

  set orderSelectState(value: string | { id: string; name: string }) {
    if (typeof value === "string") {
      let option = this.orderStateSelectConfig.listAll.find(
        item => item.id === value
      );

      if (!option) {
        option = this.orderStateSelectConfig.listAll.find(
          item => item.name === value
        );
      }

      this.orderStateModel = [
        {
          id: option?.id ?? "",
          name: option?.name ?? ""
        }
      ];
      return;
    }
    this.orderStateModel = [value];
  }

  get billTypeSelect() {
    return this.billTypeModel[0].id;
  }

  set billTypeSelect(value: string) {
    const option = this.billTypeSelectConfig.listAll.find(
      item => item.id === value
    );
    this.billTypeModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get orderPriceSelect() {
    return this.orderPriceModel[0].id;
  }

  set orderPriceSelect(value: string) {
    const option = this.orderPriceSelectConfig.listAll.find(
      item => item.id === value
    );
    this.orderPriceModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get campusSelect() {
    return this.campusModel[0].id;
  }

  set campusSelect(value: string) {
    const option = this.campusSelectConfig.listAll.find(
      item => item.id === value
    );
    this.campusModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  get cupsSelect() {
    return this.cupsModel[0].id;
  }

  set cupsSelect(value: string) {
    const option = this.cupsSelectConfig.listAll.find(
      item => item.id === value
    );
    this.cupsModel = [
      {
        id: option?.id ?? "",
        name: option?.name ?? ""
      }
    ];
  }

  @Watch("order", { deep: true })
  checkEdit() {
    if (this.edit) {
      this.invalidEdit =
        JSON.stringify(this.order) === this.editComparationStr &&
        this.invalidEditCustoms;
    }
  }
  checkCustomFieldsChanges(event: { equal: boolean }) {
    this.invalidEditCustoms = event.equal;
    this.invalidEdit = event.equal && this.invalidEdit;
  }

  @Watch("campusModel")
  campusChange() {
    this.order.campus = this.campusSelect;
  }

  @Watch("orderPriceModel")
  priceLevelChange() {
    this.order.priceLevel = this.orderPriceSelect;
  }

  @Watch("billTypeModel")
  billTypeChange() {
    this.order.billType = this.billTypeSelect;
  }

  @Watch("orderStateModel")
  orderSateChange() {
    this.order.state = this.orderStateModel[0];
  }

  @Watch("campusList")
  @Watch("diagnosisCodes")
  @Watch("serviceTemplates")
  listenLists() {
    this.getServiceTemplates();
    this.serviceSelectConfig.listAll = this.serviceTemplatesList.values.map(
      item => {
        return { id: item, name: item };
      }
    );
    this.campusToSelect = this.campusList;
    this.campusSelectConfig.listAll = this.campusToSelect.map(item => {
      return { id: item, name: item };
    });
    this.DIAGNOSIS_CODES = this.diagnosisCodes;
    this.diagnosticSelectConfig.listAll = this.DIAGNOSIS_CODES.map(item => {
      return { id: item, name: item };
    });

    this.getServiceDafault();
  }

  async preloadForm(action: ActionGeneralRules) {
    const medicalOrder = action?.medicalOrder ?? null;
    if (!medicalOrder) return;

    const serviceSelectedId = medicalOrder?.service
      ? medicalOrder?.service
      : (this.order.service as string);
    const indexServicetemplate = this.serviceTemplatesList.keys.findIndex(
      service => service === serviceSelectedId
    );
    this.selectServiceField =
      indexServicetemplate >= 0
        ? this.serviceTemplatesList.values[indexServicetemplate]
        : "";
    this.serviceSelectConfig.disabled = true;
    await this.getServiceTemplate(serviceSelectedId);
    this.order.priceLevel = medicalOrder.priceLevel.name
      ? medicalOrder.priceLevel.name
      : medicalOrder.priceLevel;
    this.orderPriceSelect = this.order.priceLevel;
    this.order.cups = medicalOrder.cups ?? "";
    this.cupsSelect = this.order.cups;
    this.order.billType = medicalOrder.billType ?? "";
    this.billTypeSelect = this.order.billType;
    this.orderSelectState = medicalOrder.state as string;
    this.order.campus = medicalOrder.campus ?? "";
    this.campusSelect = this.order.campus;
    this.order.diagnosticPrimaryCode = medicalOrder.diagnosticPrimaryCode ?? "";
    this.order.description = medicalOrder.description ?? "";
    this.order.orderType = medicalOrder.orderType ?? "";
    this.order.event = medicalOrder.event ?? "";
    this.order.type = medicalOrder.type ?? "";
    this.order.payment = medicalOrder.payment ?? 0;
    this.order.cancelValue = medicalOrder.cancelValue ?? 0;
    this.order.fields = medicalOrder.fields ?? {};
    this.daysToApply = action.daysToApply;
    this.fieldsToEdit = { ...this.order.fields };
    this.editComparationStr = JSON.stringify(this.order);
  }

  async getCups() {
    try {
      const responseData: Response<CupsPriceLevelHeader[]> = await this.cupsPriceLevelService.getAllActiveCupsPriceLevel();
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const serviceCups = responseData.data;
        this.cupsStore = responseData.data;
        serviceCups.forEach(cup => {
          this.cupsList.keys.push(cup.id);
          this.cupsList.values.push(cup.externalName);
        });
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getDiagnosticsCodes() {
    const fetchDiagnosisCodes = await this.getListDataById(
      ID_LIST.DIAGNOSIS_CODE
    );
    this.DIAGNOSIS_CODES = fetchDiagnosisCodes?.map(item => item.key) ?? [];
  }

  async getCampus() {
    const fetchCampus = await this.getListDataById(ID_LIST.CAMPUS);
    this.campusList = fetchCampus?.map(item => item.key) ?? [];
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );
        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getServiceDafault() {
    if (this.dataTransferActions.dataCondition.key != "") {
      this.selectServiceField = this.dataTransferActions.dataCondition.name;
      this.activeSelect = true;
    } else {
      this.activeSelect = false;
    }
  }

  async getServiceTemplates() {
    this.serviceTemplates.forEach((item: any) => {
      this.serviceTemplatesList.keys.push(item.id);
      this.serviceTemplatesList.values.push(item.internalName);
    });
  }

  async setService(service: string) {
    this.order.service = service;
    const indexIdTemplate = this.serviceTemplatesList.values.findIndex(
      item => item == this.order.service
    );
    await this.getServiceTemplate(
      this.serviceTemplatesList.keys[indexIdTemplate]
    );
    this.order.tracking = service;
  }

  async getServiceTemplate(id: string) {
    try {
      const responseData = await this.serviceTemplateService.getServiceTemplateById(
        id
      );
      if (
        !(responseData.code == Http.Found && responseData.data !== undefined)
      ) {
        Snackbar.popInfo(responseData.message);
        return;
      }

      this.isGroupType =
        responseData.data.type == GENERAL_RULES_CONSTANTS.GROUPS;
      this.cupsSelectConfig.listAll = [];
      if (this.isGroupType && responseData.data.groups) {
        for (const group of responseData.data.groups) {
          if (!group.cups) {
            continue;
          }
          const indexCup = this.cupsList.keys.indexOf(group.cups ?? "");
          this.cupsSelectConfig.listAll.push({
            id: this.cupsList.values[indexCup],
            name: this.cupsList.values[indexCup]
          });
        }
      } else {
        this.orderPriceSelectConfig.listAll =
          (await this.getPriceLevelListFormated(
            responseData.data?.cups ?? ""
          )) ?? [];
        const indexCup = this.cupsList.keys.indexOf(
          responseData.data?.cups ?? ""
        );
        this.order.cups = this.cupsList.values[indexCup];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getPriceLevelListFormated(cups: string) {
    const priceLevels = await this.cupsPriceLevelService.getCupsPriceLevelById(
      cups as string
    );

    if (priceLevels.code === Http.Found && priceLevels.data) {
      const priceLvls = Utils.getArrayByKeys(
        priceLevels.data.clients,
        SERVICES_CONTANTS.ATTRIBUTES
      );
      this.priceLvlsList = {
        keys: [],
        values: []
      };
      priceLvls.forEach(element => {
        if (!this.priceLvlsList.keys.find(key => key == element.key)) {
          this.priceLvlsList.keys.push(element.key);
        }

        if (
          !this.priceLvlsList.values.find(
            value => value == `${element.name} ${element.price}`
          )
        ) {
          this.priceLvlsList.values.push(`${element.name} ${element.price}`);
        }
      });
      const listAll = this.priceLvlsList.values.map(item => {
        return { id: item, name: item };
      });

      if (!this.priceLvlsList.values.includes(this.order.priceLevel)) {
        this.order.priceLevel = "";
      }
      return listAll;
    }
  }

  setCups(cups: string) {
    const findCup = this.cupsStore.find(item => item.externalName === cups);

    if (findCup !== undefined) {
      this.priceLvlsList = { keys: [], values: [] };
      for (const key in findCup.clients) {
        this.priceLvlsList.keys.push(key);
        this.priceLvlsList.values.push(
          `${findCup.clients[key].name} ${findCup.clients[key].price}`
        );
      }
    }
  }

  save() {
    this.fetchCustomFields = !this.fetchCustomFields;
  }

  getCustomFields(event: { [key: string]: MedicalOrderField }) {
    this.order.fields = event;
    this.order.orderType = this.ORDER_TYPES_LIST[0];
    const indexServicetemplate = this.serviceTemplatesList.values.findIndex(
      service => service === (this.order.service as string)
    );
    this.order.service = this.serviceTemplatesList.keys[indexServicetemplate];
    const priceLevelName = this.order.priceLevel;
    const indexPriceLevel = this.priceLvlsList.values.findIndex(
      priceLevel => priceLevel === (this.order.priceLevel as string)
    );
    this.order.priceLevel = {
      key: this.priceLvlsList.keys[indexPriceLevel],
      name: priceLevelName
    };

    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_ORDER_ACTION,
      this.order,
      this.daysToApply,
      this.cupsStore,
      this.priceLvlsList
    );
    this.resetValues();
    this.daysToApply = 0;
  }

  cancel() {
    this.cleanCustomFields = !this.cleanCustomFields;
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_MODAL);
    this.resetValues();
    this.daysToApply = 0;
  }

  resetValues() {
    this.daysToApply = 0;
    this.order = {
      user: "",
      service: "",
      cups: "",
      priceLevel: "",
      billType: "",
      state: "",
      campus: "",
      diagnosticPrimaryCode: "",
      description: "",
      orderType: "",
      event: "",
      type: "",
      payment: 0,
      cancelValue: 0,
      fields: {}
    };
  }

  @Watch("orderServiceModel")
  @Watch("order.service")
  async setCup() {
    try {
      this.order.service = this.orderServiceModel[0].id;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async onSelectCup() {
    this.order.cups = this.cupsSelect;
    const cupsId = await this.getCupsIdFromArray(this.order.cups);
    this.orderPriceSelectConfig.listAll =
      (await this.getPriceLevelListFormated(cupsId)) ?? [];
  }

  async getCupsIdFromArray(name: string) {
    const indexCup = this.cupsList.values.indexOf(name ?? "");
    return this.cupsList.keys[indexCup] ?? "";
  }
}
